document.addEventListener('DOMContentLoaded', function() {
  initProductVideos();
});

function initProductVideos() {
  const videoContainers = document.querySelectorAll('[data-video-hover]');
  
  videoContainers.forEach(container => {
    const productCard = container.closest('.product-card');
    const video = container.querySelector('video');
    const primaryImage = productCard.querySelector('.primary-image');
    const mediaContainer = productCard.querySelector('.product-media-container');
    
    if (!video || !primaryImage) return;
    
    // Prepara il video
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.muted = true; // Forza muted per autoplay
    
    let isVideoLoaded = false;
    
    productCard.addEventListener('mouseenter', function() {
      // Carica il video se non è già stato caricato
      if (!isVideoLoaded) {
        video.load();
        isVideoLoaded = true;
      }
      
      // Mostra il container del video
      container.style.display = 'block';
      
      // Nascondi l'immagine principale
      if (primaryImage) {
        primaryImage.style.opacity = '0';
      }
      
      // Riproduci il video
      video.play().catch(e => {
        console.error('Errore riproduzione video:', e);
      });
    });
    
    productCard.addEventListener('mouseleave', function() {
      // Pausa il video
      video.pause();
      video.currentTime = 0;
      
      // Nascondi il video
      container.style.display = 'none';
      
      // Mostra l'immagine principale
      if (primaryImage) {
        primaryImage.style.opacity = '1';
      }
    });
  });
}



// Reinizializza per collezioni con infinite scroll o filtri AJAX
document.addEventListener('shopify:section:load', initProductVideos);
document.addEventListener('ajaxCart:updated', initProductVideos);